module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKIEED.cb5ddc5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKIEED.png
// module id = 65
// module chunks = 0